import { Modal } from 'antd';

interface UnsavedChangesModalProps {
    open: boolean;
    onOk: () => void;
    onCancel: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({ open, onOk, onCancel }) => {
    return (
        <Modal
            title="Unsaved Changes"
            open={open}
            onOk={onOk}
            onCancel={onCancel}
        >
            <p>You have unsaved changes in the editor. Are you sure you want to leave?</p>
        </Modal>
    );
};

export default UnsavedChangesModal;